import { useState } from "react";
import { Link } from "react-router-dom";
import FAQItem from "./FAQItem";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title?: string;
  data: FAQ[];
  link: string;
}

export default function FAQSection({
  title = "Nestroots Protection FAQs",
  data,
  link
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="tw-bg-white tw-py-24">
      <div className="tw-max-w-4xl tw-mx-auto tw-px-6">
        <h2 
          className="tw-text-4xl md:tw-text-5xl tw-font-medium tw-text-center tw-mb-16 tw-text-black"
          style={{ fontFamily: "'Instrument Serif', serif" }}
        >
          {title}
        </h2>
        
        <div className="tw-divide-y tw-divide-gray-100">
          {data.map((faq, index) => (
            <FAQItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>

        <div className="tw-mt-20 tw-text-center">
          <Link
            to={link}
            className="tw-text-lg tw-font-medium tw-text-black tw-underline tw-underline-offset-4 hover:tw-text-[#916B52] tw-transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </section>
  );
}